import { InvoiceModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/outputs/invoice.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { InvoiceListPeriodStartCell } from './invoice-list-period-start.cell';
import { InvoiceListPeriodStartHeader } from './invoice-list-period-start.header';

export const InvoiceListPeriodStartColumn: IdentifiedColumnDef<
  InvoiceModel,
  InvoiceModel['periodStart']
> = {
  enableSorting: true,
  header: InvoiceListPeriodStartHeader,
  cell: InvoiceListPeriodStartCell,
  meta: { maxWidth: '165px', width: '160px' },
};
